var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 52,
    viewBox: "0 0 65 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68403 6.37875C10.0639 5.93976 10.6158 5.6875 11.1964 5.6875H42.7686C43.8731 5.6875 44.7686 6.58293 44.7686 7.6875V15.2432C44.7686 16.3477 43.8731 17.2432 42.7686 17.2432H4.65788C2.94473 17.2432 2.0245 15.2299 3.14554 13.9344L9.68403 6.37875Z",
    fill: "url(#paint0_linear_1844_4254)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4492 17.2441H57.167",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28223 16.5703H0",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 45.8001C13.7886 47.3574 13.016 50.5412 10.3868 50.8176C7.75748 51.0941 4.7938 50.9328 3.64062 50.8176V24.8707L12.6354 6.3626C13.4426 4.57507 15.9565 1 19.5544 1C23.1524 1 37.4287 1 44.1171 1C45.8469 1.28828 49.7562 2.7644 51.5551 6.3626C53.3541 9.9608 58.3012 20.2006 60.5499 24.8707V50.8176C57.9834 51.2643 52.7082 51.6959 52.14 49.8491C51.5718 48.0024 51.5481 46.3803 51.6073 45.8001",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6226 39.6699C52.6752 40.4833 42.371 41.8632 31.9035 41.8632C19.0972 41.8632 12.4803 42.1091 9.88867 39.6699",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8602 33.2031C45.4084 30.6776 46.4027 25.8021 53.9944 26.5039",
    stroke: "black",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3791 33.2031C17.8309 30.6776 16.8366 25.8021 9.24481 26.5039",
    stroke: "black",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 33.5273L43.1836 27.6074H21.3623L23.0738 33.5273H41.2Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1844_4254",
    x1: 24.5254,
    y1: 5.6875,
    x2: 24.5254,
    y2: 17.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.26c36c0a288a2dc42ee7fbed8fdae84e.svg";
export { ForwardRef as ReactComponent };